import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import setUpMixins from '@/utils/mixins'

const app = createApp(App)

setUpMixins(app, vuetify)

app.use(router)
app.use(store)
app.use(vuetify)

app.config.productionTip = false

app.mount('#app')
